import AlexStates from 'a/components/GameHeader/AlexStates';

import { GAME_ID, REDUX_ACTIONS, CURRICULUM_TYPES } from '../../data/constants';

const initialState = {
  alexState: AlexStates.INACTIVE,
  hasOnboarded: {
    [CURRICULUM_TYPES.ONSETRIMES]: false,
    [CURRICULUM_TYPES.PHONEMES]: false,
    [CURRICULUM_TYPES.COMPOUNDS]: false,
    [CURRICULUM_TYPES.SYLLABLES]: false,
  },
  hasOnboardedMetagame: {
    [CURRICULUM_TYPES.ONSETRIMES]: false,
    [CURRICULUM_TYPES.PHONEMES]: false,
    [CURRICULUM_TYPES.COMPOUNDS]: false,
    [CURRICULUM_TYPES.SYLLABLES]: false,
  },
  lastLevelUnlocked: 0,
  isOnboardingHelp: false,
};

// handles session state and other non-persistant data

const botManagerReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // update state when gamestate data has been received
    case REDUX_ACTIONS.SET_ALEX_ACTIVE:
      return {
        ...state,
        alexState: AlexStates.ACTIVE,
      };

    case REDUX_ACTIONS.SET_ALEX_SPEAKING:
      return {
        ...state,
        alexState: AlexStates.SPEAKING,
      };

    case REDUX_ACTIONS.SET_ALEX_INACTIVE:
      return {
        ...state,
        alexState: AlexStates.INACTIVE,
      };

    case REDUX_ACTIONS.COMPLETE_ONBOARDING: {
      const onboardingType = payload.isQuestWorkflow ? 'hasOnboardedMetagame' : 'hasOnboarded';
      return {
        ...state,
        [onboardingType]: {
          ...state[onboardingType],
          [payload.curriculumType]: true,
        },
        isOnboardingHelp: false,
      };
    }

    case REDUX_ACTIONS.START_HELP:
      return {
        ...state,
        isOnboardingHelp: true,
      };

    case REDUX_ACTIONS.EXIT_ONBOARDING:
      return {
        ...state,
        isOnboardingHelp: false,
      };

    case REDUX_ACTIONS.UNLOCK_LEVEL:
      return {
        ...state,
        lastLevelUnlocked: payload.level,
      };

    default:
      return state;
  }
};

export default botManagerReducer;
